import type {
  NumerologyRequest,
  NameNumberResponse,
  NumerologyResponse,
} from "@ishvaram/api-client";
import { apiRequest } from "./_fetch";

export type { NumerologyRequest, NumerologyResponse };
export type { NameNumberResponse, NumberResult } from "@ishvaram/api-client";

export async function calculateNumerology(data: NumerologyRequest): Promise<NumerologyResponse> {
  return apiRequest<NumerologyResponse>("/numerology", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

export async function calculateNameNumber(name: string): Promise<NameNumberResponse> {
  return apiRequest<NameNumberResponse>("/numerology/name", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name }),
  });
}
